import { State, Action, Selector, StateContext, Store } from '@ngxs/store';
import { LoginRequest, InitAuthState, LogoutRequest } from './auth.actions';
import { Observable } from 'rxjs';
import { LocalStorageService } from '@leagueplay/shared/local-storage';
import { NgZone } from '@angular/core';
import { Router } from '@angular/router';

export interface AuthStateModel {
  loading: boolean;
  user: { username: string };
  token: string;
  error: boolean;
}

const TOKEN = 'token';

@State<AuthStateModel>({
  name: 'auth',
  defaults: {
    loading: false,
    user: null,
    token: null,
    error: null
  }
})
export class AuthState {
  constructor(
    private store: Store,
    private ngZone: NgZone,
    private router: Router,
    private storage: LocalStorageService
  ) {
    setTimeout(() => {
      this.store.dispatch(new InitAuthState());
    }, 0);
  }

  @Selector()
  public static loading(state: AuthStateModel) {
    return state.loading;
  }

  @Selector()
  public static user(state: AuthStateModel) {
    return state.user;
  }

  @Selector()
  public static error(state: AuthStateModel) {
    return state.error;
  }

  @Action(InitAuthState)
  public init(ctx: StateContext<AuthStateModel>, action: InitAuthState) {
    const token = this.storage.get(TOKEN);
    const user = token ? this.readToken(token) : null;

    const state = ctx.getState();
    state.token = token;
    state.user = user;
    state.loading = false;
    state.error = false;
    ctx.patchState(state);
  }

  @Action(LogoutRequest)
  public logout(
    ctx: StateContext<AuthStateModel>,
    { returnUrl }: LogoutRequest
  ) {
    this.storage.delete(TOKEN);
    const state = ctx.getState();
    state.user = null;
    state.token = null;
    ctx.patchState(state);
    this.ngZone.run(() => {
      this.router.navigateByUrl(returnUrl);
    });
  }

  @Action(LoginRequest)
  public login(
    ctx: StateContext<AuthStateModel>,
    { username, password, returnUrl }: LoginRequest
  ) {
    // This is all throw-away for the sake of testing observables.

    const state = ctx.getState();
    state.loading = true;
    ctx.patchState(state);

    const sub = this.authenticate$(username, password).subscribe(
      token => {
        // next
        state.user = { username };
        console.log('seting user to ', state.user);
        state.token = token;
        state.loading = false;
        state.error = false;

        console.log('token', token);
        this.storage.save(TOKEN, token);

        ctx.patchState(state);

        this.redirectTo(returnUrl);
      },
      err => {
        // error
        state.loading = false;
        state.error = true;
        ctx.patchState(state);
        sub.unsubscribe();
      },
      () => {
        // success
        state.loading = false;
        state.error = false;
        ctx.patchState(state);
        sub.unsubscribe();
      }
    );
  }

  private authenticate$(username: string, password: string): Observable<any> {
    return new Observable(subscriber => {
      setTimeout(() => {
        if (!this.authenticates(username, password)) {
          subscriber.error('Unable to authenticate');
          return;
        }

        const token = btoa(
          JSON.stringify({
            username
          })
        );

        subscriber.next(token);
        subscriber.complete();
      }, 3000);
    });
  }

  private authenticates(username: string, password: string): boolean {
    if (
      (username.toLowerCase() === 'unreal' && password === 'password') ||
      (username.toLowerCase() === 'underdog' && password === 'password') ||
      (username.toLowerCase() === 'balance' && password === 'password')
    ) {
      return true;
    }

    return false;
  }

  private redirectTo(url: string) {
    this.ngZone.run(() => {
      this.router.navigateByUrl(url);
    });
  }

  private readToken(token: string): any {
    return JSON.parse(atob(token));
  }
}
